import React from 'react';
import { motion } from 'framer-motion';
import { SingleBulletCarousel } from './SingleBulletCarousel';
import { HerDemoVideo } from './HerDemoVideo';

// "Cómo funciona": sección de confianza basada solo en hechos del producto.
// Reemplaza a la sección de testimonios en la landing; components/TestimonialsSection.tsx
// queda intacto y sin renderizarse.
//
// REGLA: solo se afirma lo que la compradora recibe HOY. La experiencia diaria interactiva
// (Día 1 → Día 21) todavía es un prototipo de la Fase H: no se promete acá hasta que se entregue.
// Hoy lo interactivo y optimizado para el celular es el Recetario; el resto es ebook digital.
//
// En lugar de "H.E.R. es para vos si… / H.E.R. no es…" (plantilla de segmentación), se parte de la
// situación y la necesidad: "¿En qué momento estás?" → "H.E.R. puede acompañarte si buscás…" → aclaración.
const STEPS = [{
  num: '01',
  title: 'Elegís tu acceso',
  text: 'Dejás tu email y completás el pago con Mercado Pago, en un solo pago o en cuotas.'
}, {
  num: '02',
  title: 'Recibís tu acceso por email',
  text: 'Con el Protocolo H.E.R. de 21 días y las herramientas que lo acompañan.'
}, {
  num: '03',
  title: 'Seguís el recorrido a tu ritmo',
  text: 'Tres fases de 7 días (días 1–7, 8–14 y 15–21), con comida, movimiento y descanso en cada una.'
}];
const RECORRIDO = ['Protocolo H.E.R. · 21 días', 'Tracker H.E.R.'];
const KIT = ['Recetario H.E.R. · 63 recetas', 'H.E.R. Movement', 'Noche en Calma', 'Guía de compras Argentina'];
const MOMENTO = ['Sentís que tu cuerpo está cambiando y ya no responde igual a las rutinas que antes te funcionaban.', 'Querés ordenar tu alimentación, pero no querés vivir siguiendo reglas cada vez más estrictas.', 'Sabés que necesitás moverte y descansar mejor, pero te cuesta convertirlo en una rutina sostenible.', 'Tenés muchas recomendaciones dando vueltas y necesitás una forma clara de llevarlas a la práctica.'];
const PUEDE_ACOMPANARTE = ['Un recorrido concreto para empezar sin tener que decidir por dónde arrancar.', 'Herramientas para observar cómo te sentís y registrar tu propio proceso.', 'Una combinación de alimentación, movimiento y descanso reunida en un mismo lugar.', 'Una estructura de 21 días que después podés adaptar a tu ritmo.'];
function ItemList({
  items
}: {
  items: string[];
}) {
  return <ul className="mt-3 space-y-2.5" data-id="element-316" data-mp="16xxuvqv1njke">
      {items.map(item => <li key={item} className="flex gap-2.5 font-body text-[14.5px] leading-snug text-[#F0E8D8]/80" data-id="element-317" data-mp="j7ajuwpu0dtm">
          <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-[#C8A870]" aria-hidden="true" data-id="element-318" data-mp="e8h1oqzlnyn4" />
          <span data-id="element-319" data-mp="s7qkzzj3r8vb">{item}</span>
        </li>)}
    </ul>;
}
function Eyebrow({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="uppercase tracking-[0.22em] text-[#C8A870]" style={{
    fontSize: '12.5px',
    fontFamily: 'sans-serif',
    fontWeight: 600
  }} data-id="element-320" data-mp="n7udhqb74zb0">
      {children}
    </p>;
}
const fade = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.55
  }
};
export function HowItWorksSection() {
  return <section className="bg-gradient-section px-4 py-12 md:px-8 md:py-16" style={{
    paddingTop: '0px'
  }} data-id="element-321" data-mp="2b7ppafql0cyo">
      <div className="mx-auto max-w-2xl space-y-8" data-id="element-322" data-mp="1x86t8lb1os2q">
        <motion.div {...fade} className="space-y-3 text-center" data-id="element-323" data-mp="225q9fqrazexb">
          
          
        </motion.div>

        

        {/* Tu recorrido / Tu kit */}
        <motion.div {...fade} className="grid gap-4 md:grid-cols-2" data-id="element-324" data-mp="2pwchvj57z17u">
          
          
        </motion.div>
        

        {/* Tu ebook digital: solo lo que se recibe hoy */}
        

        {/* ¿En qué momento estás? */}
        <motion.div {...fade} data-id="element-325" data-mp="2l4uhaw73z2ne">
          <Eyebrow data-id="element-326" data-mp="2l42jdeq1gsty">¿En qué momento estás?</Eyebrow>
          <p className="mt-2 font-display text-[22px] font-semibold leading-tight text-[#F0E8D8]" data-id="element-327" data-mp="2l2rjvr3mm78n">
            Quizás te pase que…
          </p>
          <ItemList items={MOMENTO} data-id="element-328" data-mp="3dlevmfwqg9x2" />
        </motion.div>

        <div className="divider-fine mx-auto w-16" data-id="element-329" data-mp="3dmyfshlif544" />

        {/* Video de demostración: así se ve H.E.R. por dentro (inmediatamente debajo de "¿En qué momento estás?") */}
        <HerDemoVideo data-id="element-330" data-mp="1kw5wfjzqop88" />

        {/* H.E.R. puede acompañarte si buscás… */}
        

        {/* Una aclaración importante (misma definición que la Guía) */}
        

        

        
      </div>
    </section>;
}